<template>
  <div>
    <edit-profile :isFromToken="true" :isConsultant="false"/>
  </div>
</template>

<script>
import EditProfile from '@/components/profile/EditProfile.vue'

export default {
  components: {
    EditProfile
  },
}
</script>